import { registerBlockType } from '@wordpress/blocks';
import { __ } from '@wordpress/i18n';
import { ToggleControl } from '@wordpress/components';
import Label from 'Components/Label';

import Placeholder from 'Components/Placeholder';
import FormSelect, { formOptions } from 'Components/FormSelect';

registerBlockType('eformv4/embed-form', {
	title: __('Embed Form - eForm', 'ipt_fsqm'),
	icon: 'feedback',
	category: 'eform-v4',
	attributes: {
		formId: {
			type: 'string',
			default: '',
		},
		iframe: {
			type: 'string',
			default: '0',
		},
	},

	edit({ attributes, className, setAttributes }) {
		const { formId, iframe } = attributes;

		const onChangeId = selected =>
			setAttributes({ formId: selected.value });

		const selectedForm = formOptions.find(form => form.value === formId);

		const title =
			__('Embed Form : ', 'ipt_fsqm') +
			(selectedForm
				? selectedForm.label
				: __('Please select a form', 'ipt_fsqm'));
		const message = __('Embed eForm into content.', 'ipt_fsqm');

		return (
			<Placeholder className={className} title={title} message={message}>
				<FormSelect
					id="eform-gtb-embed-form-id"
					onChange={onChangeId}
					value={selectedForm}
				/>
				<Label title={__('Use iFrame', 'ipt_fsqm')}>
					<ToggleControl
						checked={iframe === '1'}
						onChange={isChecked => {
							setAttributes({ iframe: isChecked ? '1' : '0' });
						}}
						label={__('Embed in iFrame?', 'ipt_fsqm')}
						help={__(
							'If enabled, form will be embedded inside an iframe, which may fix some appearance issues with some themes. Use if your content window is too short or if the form is breaking on the page.',
							'ipt_fsqm'
						)}
					/>
				</Label>
			</Placeholder>
		);
	},

	save() {
		return null;
	},
});
